var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuardados(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2191 0.181885C9.59604 0.181885 8.28027 1.49765 8.28027 3.12072V21.9179C8.28027 22.0865 8.41695 22.2232 8.58556 22.2232C8.64685 22.2232 8.70673 22.2047 8.75739 22.1702L16.3164 17.0227C16.5659 16.8528 16.894 16.8528 17.1435 17.0227L24.7027 22.1703C24.7532 22.2048 24.8129 22.2232 24.8741 22.2232C25.0422 22.2232 25.1786 22.0868 25.1786 21.9186V3.12072C25.1786 1.49765 23.8628 0.181885 22.2397 0.181885H11.2191Z",
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48864 2.97925C5.86557 2.97925 4.5498 4.29501 4.5498 5.91809V24.7154C4.5498 24.8839 4.68643 25.0205 4.85497 25.0205C4.91624 25.0205 4.97609 25.0021 5.02673 24.9676L12.5858 19.8201C12.8353 19.6502 13.1633 19.6502 13.4128 19.8201L20.972 24.9677C21.0226 25.0021 21.0823 25.0205 21.1435 25.0205C21.3117 25.0205 21.4481 24.8841 21.4481 24.7159V5.91808C21.4481 4.29501 20.1324 2.97925 18.5093 2.97925H7.48864Z",
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75915 5.77686C2.13607 5.77686 0.820312 7.09262 0.820312 8.71569V27.5128C0.820312 27.6814 0.957 27.8181 1.12561 27.8181C1.18691 27.8181 1.24679 27.7997 1.29745 27.7652L8.85627 22.6178C9.10578 22.4479 9.43383 22.4479 9.68335 22.6178L17.2423 27.7653C17.2929 27.7997 17.3526 27.8181 17.4138 27.8181C17.5822 27.8181 17.7186 27.6817 17.7186 27.5133V8.71569C17.7186 7.09262 16.4029 5.77686 14.7798 5.77686H3.75915Z",
    fill: "#EFF4F1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuardados);
export default __webpack_public_path__ + "static/media/guardados.0b1048cd77a7dcdde373911a0863aef1.svg";
export { ForwardRef as ReactComponent };